/*
 * 知乎 - 热榜（服务端路由）
 */
export async function fetchZhihuHot() {
  const res = await fetch('/server-api/zhihu')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
